import type { TFunction } from "i18next";
import type { TPortfolioStatus } from "../const/const";

export type TProjectStatusSource = {
  isDraft?: boolean;
  isGenerating?: boolean;
  chaptersTotal?: number;
  chaptersGenerated?: number;
  framingPercent?: number;
};

export type TProjectStatus = {
  state: "complete" | "generating" | "framing";
  name: TPortfolioStatus;
};

export function getProjectStatus(source: TProjectStatusSource): TProjectStatus {
  const generated = source.chaptersGenerated ?? 0;

  if (source.isGenerating) return { state: "generating", name: "Generating" };
  if (source.isDraft || generated === 0) return { state: "framing", name: "Framing" };
  return { state: "complete", name: "Complete" };
}

export function getProjectStatusLabel(t: TFunction<"projects">, source: TProjectStatusSource): string {
  const total = source.chaptersTotal ?? 0;
  const generated = source.chaptersGenerated ?? 0;

  if (source.isGenerating) return t("status.generatingProgress", { generated, total });
  if (source.isDraft || generated === 0) {
    return t("status.framingProgress", { percent: source.framingPercent ?? 0 });
  }
  return t("status.completeProgress", { generated, total });
}
